import {
  createTheme, CssBaseline, ThemeProvider,
} from '@mui/material'
import type { CreateThemeOptions } from '@xylabs/react-theme'
import { XyoThemeOptions } from '@xylabs/react-theme'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { AppBody } from './AppBody.tsx'
import { isRtlLanguage } from './i18n/index.ts'
import { ThemeOverrides } from './ThemeOverrides.tsx'

export const AppThemeBody: React.FC = () => {
  const { i18n } = useTranslation()
  const rtl = useMemo(() => {
    const rtl = isRtlLanguage(i18n.language)
    document.documentElement.setAttribute('dir', rtl ? 'rtl' : 'ltr')
    return rtl
  }, [i18n.language])

  const theme = useMemo(
    () =>
      createTheme(
        XyoThemeOptions,
        ThemeOverrides ?? {},
        { direction: rtl ? 'rtl' : 'ltr' },
      ),
    [rtl],
  )

  return (
    <ThemeProvider
      theme={theme}
      defaultMode="dark"
    >
      <CssBaseline enableColorScheme />
      <AppBody />
    </ThemeProvider>
  )
}
